import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {Tag} from '@vio/atlas/Tag'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  isOnlySplitBookingOfferAvailable?: boolean
  savingPercentage?: number
}

export const SplitBookingCardHeader = ({
  isOnlySplitBookingOfferAvailable = false,
  savingPercentage
}: Props) => {
  return (
    <Box display="flex" gap="s300" alignItems="flex-end">
      <Box display="flex" flexDirection="column" gap="s100">
        {isOnlySplitBookingOfferAvailable ? (
          <Text
            variant="titleS"
            colorPath="content.success.secondary"
            dataId="vioExclusiveTitle"
          >
            <FormattedMessageWrapper
              id="splitBooking.vioExclusiveTitle"
              defaultMessage="Vio.com exclusive"
            />
          </Text>
        ) : null}
        <Text variant="titleL">
          {isOnlySplitBookingOfferAvailable ? (
            <FormattedMessageWrapper
              id="splitBooking.onlyOfferCardTitle"
              defaultMessage="Switch rooms to stay here"
              dataId="splitBooking.onlyOfferCardTitle"
            />
          ) : (
            <FormattedMessageWrapper
              id="switchRoomsAndSave"
              defaultMessage="Switch rooms and save"
              dataId="splitBooking.cardTitle"
            />
          )}
        </Text>
      </Box>
      {Boolean(savingPercentage && savingPercentage > 0) && (
        <Tag variant="success" size="sm" dataId="splitBooking.savingTag">
          <FormattedMessageWrapper
            id="splitBooking.saveTagOff"
            defaultMessage="-{savingPercentage}% off"
            values={{
              savingPercentage
            }}
          />
        </Tag>
      )}
    </Box>
  )
}
